module.exports = __webpack_public_path__ + "static/media/attack.8ef526ef.mp3";